import * as React from 'react';
const DesktopAlertSVG = (props) => (
  <svg width={213} height={155} viewBox="0 0 213 155" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M104.441 0C50.2731 0 6.56016 44.0602 6.8052 98.4113C6.89969 119.368 13.5154 138.794 24.7145 154.755H185.562C196.618 138.794 203.058 119.368 202.964 98.4113C202.719 44.0602 158.608 0 104.441 0Z"
      fill="url(#paint0_linear_1700_1071)"
      fillOpacity={0.2}
    />
    <path d="M5.54898 107.521L1.8414 107.917L5.73836 144.771L9.44593 144.374L5.54898 107.521Z" fill="#40B48E" />
    <mask
      id="mask0_1700_1071"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={1}
      y={107}
      width={9}
      height={38}
    >
      <path d="M5.54898 107.521L1.8414 107.917L5.73836 144.771L9.44593 144.374L5.54898 107.521Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1700_1071)">
      <path
        d="M1.90679 108.676C1.84038 108.676 1.783 108.625 1.7761 108.557C1.76866 108.485 1.82072 108.419 1.89351 108.411L5.58268 108.017C5.65493 108.011 5.72027 108.062 5.72771 108.135C5.73515 108.208 5.68309 108.274 5.6103 108.281L1.92113 108.675C1.91635 108.675 1.91157 108.676 1.90679 108.676Z"
        fill="#313133"
      />
    </g>
    <path d="M6.90245 109.501L1.69873 110.058L2.10451 113.895L7.30823 113.339L6.90245 109.501Z" fill="#313133" />
    <path d="M7.22905 112.812L6.68173 112.871L7.73464 122.828L8.28196 122.769L7.22905 112.812Z" fill="#313133" />
    <path d="M7.95122 120.957H7.40082V122.841H7.95122V120.957Z" fill="#313133" />
    <path d="M17.8431 113.934L13.6649 150.757L16.5929 151.093L20.7711 114.27L17.8431 113.934Z" fill="#FFC72C" />
    <mask
      id="mask1_1700_1071"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={13}
      y={113}
      width={8}
      height={39}
    >
      <path d="M17.8431 113.934L13.6649 150.757L16.5929 151.093L20.7711 114.27L17.8431 113.934Z" fill="white" />
    </mask>
    <g mask="url(#mask1_1700_1071)">
      <path
        d="M15.6195 151.901C15.6147 151.901 15.6094 151.901 15.6046 151.9C15.5324 151.891 15.4803 151.825 15.4888 151.753L19.6147 115.388C19.6232 115.315 19.6891 115.264 19.7608 115.272C19.833 115.28 19.8851 115.345 19.8766 115.419L15.7507 151.783C15.7433 151.851 15.6859 151.901 15.62 151.901H15.6195Z"
        fill="#313133"
      />
      <path
        d="M14.5967 151.725C14.592 151.725 14.5866 151.725 14.5819 151.724C14.5096 151.715 14.4575 151.65 14.466 151.577L18.5919 115.212C18.6004 115.14 18.6658 115.087 18.738 115.096C18.8103 115.104 18.8623 115.17 18.8538 115.243L14.728 151.607C14.7205 151.675 14.6631 151.725 14.5973 151.725H14.5967Z"
        fill="#313133"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.971 113.498C20.996 113.279 20.8393 113.08 20.6209 113.056C20.0445 112.99 18.9793 112.867 18.4029 112.802C18.185 112.776 17.9879 112.934 17.963 113.154C17.8923 113.776 17.7637 114.908 17.7637 114.908L20.7718 115.253C20.7718 115.253 20.9004 114.12 20.971 113.499V113.498Z"
      fill="white"
    />
    <path d="M17.5383 113.757L17.2941 115.909L20.9299 116.326L21.1741 114.174L17.5383 113.757Z" fill="#FAC613" />
    <mask
      id="mask2_1700_1071"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={17}
      y={113}
      width={5}
      height={4}
    >
      <path d="M17.5383 113.757L17.2941 115.909L20.9299 116.326L21.1741 114.174L17.5383 113.757Z" fill="white" />
    </mask>
    <g mask="url(#mask2_1700_1071)">
      <path
        d="M21.4609 115.409C21.4561 115.409 21.4508 115.409 21.446 115.408L17.0694 114.906C16.9971 114.898 16.9451 114.832 16.9536 114.759C16.9621 114.686 17.0274 114.634 17.0997 114.643L21.4763 115.145C21.5486 115.154 21.6006 115.219 21.5921 115.292C21.5847 115.36 21.5273 115.409 21.4614 115.409H21.4609Z"
        fill="white"
      />
      <path
        d="M21.3966 116.028C21.3919 116.028 21.3866 116.028 21.3818 116.027L17.0051 115.525C16.9329 115.516 16.8808 115.451 16.8893 115.378C16.8978 115.305 16.9632 115.253 17.0354 115.262L21.412 115.764C21.4843 115.772 21.5364 115.838 21.5279 115.911C21.5204 115.979 21.4631 116.028 21.3972 116.028H21.3966Z"
        fill="white"
      />
      <path
        d="M21.4785 114.786C21.4737 114.786 21.4684 114.786 21.4636 114.785L17.0869 114.283C17.0147 114.275 16.9626 114.209 16.9711 114.136C16.9796 114.063 17.045 114.012 17.1172 114.02L21.4939 114.522C21.5661 114.531 21.6182 114.596 21.6097 114.669C21.6022 114.737 21.5449 114.786 21.479 114.786H21.4785Z"
        fill="white"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4256 109.675L13.5369 106.879L15.1291 109.897L14.6728 111.862L11.8815 111.563L11.4256 109.675Z"
      fill="white"
    />
    <mask
      id="mask3_1700_1071"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={11}
      y={106}
      width={5}
      height={6}
    >
      <path
        d="M11.4256 109.675L13.5369 106.879L15.1291 109.897L14.6728 111.862L11.8815 111.563L11.4256 109.675Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_1700_1071)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8483 107.418C12.8483 107.418 13.4088 107.842 14.269 107.573L13.7138 106.43L12.8483 107.418Z"
        fill="#EB3E3E"
      />
    </g>
    <path d="M11.4207 109.666L9.18369 146.659L12.9053 146.887L15.1423 109.894L11.4207 109.666Z" fill="#C6CBD6" />
    <mask
      id="mask4_1700_1071"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={9}
      y={109}
      width={7}
      height={38}
    >
      <path d="M11.4207 109.666L9.18369 146.659L12.9053 146.887L15.1423 109.894L11.4207 109.666Z" fill="white" />
    </mask>
    <g mask="url(#mask4_1700_1071)">
      <path
        d="M10.1994 147.204C10.1968 147.204 10.1941 147.204 10.1915 147.204C10.1187 147.2 10.0634 147.137 10.0677 147.064L12.3399 109.468C12.3442 109.395 12.4074 109.338 12.4797 109.343C12.5524 109.347 12.6077 109.411 12.6034 109.484L10.3312 147.08C10.3269 147.15 10.269 147.204 10.2 147.204H10.1994Z"
        fill="#313133"
      />
      <path
        d="M11.7555 147.322C11.7528 147.322 11.7502 147.322 11.7475 147.322C11.6747 147.318 11.6195 147.255 11.6237 147.181L13.896 109.585C13.9002 109.512 13.9634 109.456 14.0357 109.461C14.1085 109.465 14.1637 109.528 14.1595 109.601L11.8872 147.197C11.883 147.268 11.8251 147.322 11.756 147.322H11.7555Z"
        fill="#313133"
      />
    </g>
    <path
      d="M22.21 124.165H0.233307V144.179C0.233307 148.62 3.83379 152.221 8.27521 152.221H14.1681C18.6095 152.221 22.21 148.62 22.21 144.179V124.165Z"
      fill="#51D497"
    />
    <rect x={0.233276} y={129.191} width={21.9193} height={1.88174} fill="#ABFAD5" />
    <path
      d="M33.9141 67.3565C33.9141 66.1722 34.8742 65.212 36.0586 65.212H168.364C169.548 65.212 170.509 66.1722 170.509 67.3565V146.665H33.9141V67.3565Z"
      fill="#1D3557"
    />
    <g filter="url(#filter0_i_1700_1071)">
      <path
        d="M23.7563 146.665H180.399C180.399 149.782 177.871 152.31 174.754 152.31H29.4016C26.2838 152.31 23.7563 149.782 23.7563 146.665Z"
        fill="#1D3557"
      />
    </g>
    <path
      d="M91.3854 146.665H113.037C113.037 148.595 111.473 150.159 109.543 150.159H94.88C92.95 150.159 91.3854 148.595 91.3854 146.665Z"
      fill="#A6C3EC"
    />
    <g clipPath="url(#clip0_1700_1071)">
      <rect width={130.179} height={75.0008} transform="translate(37.1218 68.4379)" fill="#CAFFE6" />
      <g opacity={0.21} filter="url(#filter1_d_1700_1071)">
        <ellipse cx={102.078} cy={106.073} rx={38.4924} ry={38.7101} fill="#E2FFF2" />
      </g>
      <g opacity={0.24} filter="url(#filter2_d_1700_1071)">
        <ellipse cx={102.078} cy={106.073} rx={29.9385} ry={30.1079} fill="#E2FFF2" />
      </g>
      <g opacity={0.39} filter="url(#filter3_d_1700_1071)">
        <ellipse cx={102.078} cy={106.073} rx={22.4539} ry={22.5809} fill="#E2FFF2" />
      </g>
      <g opacity={0.51} filter="url(#filter4_d_1700_1071)">
        <ellipse cx={102.078} cy={106.073} rx={16.0385} ry={16.1292} fill="#E2FFF2" />
      </g>
      <g filter="url(#filter5_d_1700_1071)">
        <path
          d="M109.696 125.159L103.147 106.61L121.859 111.584L117.582 116.288L123.329 121.664L119.453 125.965L113.839 120.455L109.696 125.159Z"
          fill="white"
        />
        <path
          d="M109.443 125.248C109.475 125.338 109.552 125.404 109.645 125.422C109.738 125.44 109.834 125.407 109.897 125.336L113.853 120.844L119.265 126.157C119.317 126.208 119.388 126.236 119.461 126.233C119.534 126.231 119.603 126.199 119.652 126.145L123.528 121.844C123.626 121.735 123.619 121.568 123.512 121.469L117.958 116.273L122.057 111.764C122.12 111.695 122.142 111.598 122.116 111.508C122.089 111.418 122.018 111.348 121.927 111.324L103.216 106.351C103.12 106.326 103.017 106.355 102.95 106.428C102.883 106.502 102.861 106.606 102.894 106.7L109.443 125.248Z"
          stroke="#1D3557"
          strokeWidth={0.536126}
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter6_d_1700_1071)">
        <path
          d="M109.696 125.159L103.147 106.61L121.391 123.815L119.453 125.965L113.839 120.455L109.696 125.159Z"
          fill="#F0F0F0"
        />
      </g>
      <g filter="url(#filter7_d_1700_1071)">
        <path
          d="M98.87 111.046L94.994 115.213M97.6671 106.745H91.92M98.87 102.444L94.994 98.5457M103.013 100.831V95.4543M107.29 102.444L111.166 98.5457"
          stroke="#51D497"
          strokeWidth={1.87644}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <path
      d="M199.296 150.471C199.289 150.471 199.283 150.47 199.276 150.469L194.94 149.657C194.88 149.646 194.841 149.589 194.853 149.53L205.91 89.8079C205.916 89.7793 205.932 89.7542 205.955 89.7378C205.979 89.7215 206.008 89.7149 206.037 89.7207L210.374 90.5325C210.433 90.5435 210.472 90.6008 210.46 90.6599L199.403 150.381C199.398 150.41 199.381 150.435 199.358 150.452C199.339 150.464 199.318 150.471 199.296 150.471L199.296 150.471ZM195.086 149.462L199.209 150.234L210.227 90.7273L206.104 89.9551L195.086 149.462H195.086Z"
      fill="#313133"
    />
    <path
      d="M207.434 98.1424C207.405 98.1424 207.378 98.1314 207.358 98.1111L162.236 53.8329C162.193 53.7905 162.192 53.7213 162.234 53.6782L165.489 50.3241C165.509 50.3034 165.537 50.2915 165.565 50.291C165.591 50.2919 165.622 50.302 165.643 50.3223L210.764 94.6006C210.807 94.6429 210.808 94.7121 210.766 94.7553L207.512 98.1094C207.491 98.1301 207.464 98.142 207.435 98.1424H207.434ZM162.466 53.7526L207.432 97.878L210.534 94.6804L165.568 50.555L162.466 53.7526Z"
      fill="#313133"
    />
    <path
      d="M195.336 147.175C195.326 147.175 195.316 147.173 195.306 147.171C195.249 147.154 195.215 147.094 195.231 147.036L208.811 98.0353L204.338 94.3401C204.333 94.3362 204.329 94.3322 204.325 94.3278L169.058 53.7064C169.019 53.661 169.023 53.5918 169.069 53.5521C169.114 53.5124 169.183 53.5173 169.222 53.5627L204.484 94.1775L209.004 97.9124C209.037 97.9397 209.051 97.9847 209.04 98.0261L195.441 147.095C195.428 147.143 195.384 147.175 195.337 147.175L195.336 147.175Z"
      fill="#313133"
    />
    <path
      d="M207.475 99.518C210.493 99.518 212.94 97.0573 212.94 94.0219C212.94 90.9865 210.493 88.5258 207.475 88.5258C204.456 88.5258 202.01 90.9865 202.01 94.0219C202.01 97.0573 204.456 99.518 207.475 99.518Z"
      fill="#51D497"
    />
    <path
      d="M207.475 97.4645C209.366 97.4645 210.899 95.9232 210.899 94.0219C210.899 92.1205 209.366 90.5792 207.475 90.5792C205.585 90.5792 204.052 92.1205 204.052 94.0219C204.052 95.9232 205.585 97.4645 207.475 97.4645Z"
      fill="#24C178"
    />
    <path
      d="M207.475 97.5743C205.528 97.5743 203.943 95.9811 203.943 94.0219C203.943 92.0628 205.527 90.4695 207.475 90.4695C209.423 90.4695 211.008 92.0628 211.008 94.0219C211.008 95.9811 209.423 97.5743 207.475 97.5743ZM207.475 90.6886C205.648 90.6886 204.161 92.184 204.161 94.0219C204.161 95.8598 205.648 97.3553 207.475 97.3553C209.303 97.3553 210.79 95.8598 210.79 94.0219C210.79 92.184 209.303 90.6886 207.475 90.6886Z"
      fill="#313133"
    />
    <path
      d="M154.895 73.3099C158.446 73.3099 161.324 70.4149 161.324 66.8437C161.324 63.2725 158.446 60.3775 154.895 60.3775C151.344 60.3775 148.465 63.2725 148.465 66.8437C148.465 70.4149 151.344 73.3099 154.895 73.3099Z"
      fill="#FFC72C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M173.013 50.8689C173.405 50.4268 173.607 49.8454 173.574 49.2544C173.54 48.6629 173.275 48.1093 172.835 47.7149C172.369 47.2966 171.862 46.8422 171.397 46.4244C170.957 46.0299 170.379 45.8267 169.792 45.8607C169.204 45.8937 168.653 46.1617 168.26 46.6038L164.432 50.9182L169.184 55.1833C169.184 55.1833 171.442 52.6385 173.013 50.8689H173.013Z"
      fill="#24C178"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M172.997 55.4561C173.814 54.5354 173.734 53.1237 172.819 52.3021L166.836 46.9325C165.921 46.111 164.518 46.1912 163.701 47.1119C160.973 50.1848 155.43 56.4324 155.43 56.4324L164.727 64.7761C164.727 64.7761 170.271 58.5286 172.998 55.4557L172.997 55.4561Z"
      fill="#51D497"
    />
    <mask
      id="mask5_1700_1071"
      style={{
        maskType: 'luminance',
      }}
      maskUnits="userSpaceOnUse"
      x={155}
      y={46}
      width={19}
      height={19}
    >
      <path
        d="M172.997 55.4561C173.814 54.5354 173.734 53.1237 172.819 52.3021L166.836 46.9325C165.921 46.111 164.518 46.1912 163.701 47.1119C160.973 50.1848 155.43 56.4324 155.43 56.4324L164.727 64.7761C164.727 64.7761 170.271 58.5286 172.998 55.4557L172.997 55.4561Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_1700_1071)">
      <path
        d="M162.545 58.1632C162.52 58.1632 162.494 58.1539 162.473 58.1354C162.428 58.0953 162.425 58.0261 162.464 57.9811L167.649 52.1386C167.689 52.0936 167.758 52.0897 167.803 52.1298C167.847 52.1699 167.851 52.2391 167.811 52.284L162.627 58.1266C162.605 58.1508 162.575 58.1632 162.545 58.1632Z"
        fill="#313133"
      />
      <path
        d="M165.047 60.4079C165.021 60.4079 164.995 60.3986 164.974 60.3801C164.93 60.34 164.926 60.2708 164.966 60.2259L170.15 54.3833C170.19 54.3384 170.259 54.3344 170.304 54.3745C170.348 54.4146 170.352 54.4838 170.312 54.5288L165.128 60.3713C165.106 60.3955 165.076 60.4079 165.047 60.4079Z"
        fill="#313133"
      />
      <path
        d="M160.044 55.9184C160.018 55.9184 159.993 55.9092 159.972 55.8907C159.927 55.8506 159.923 55.7814 159.963 55.7364L165.148 49.8939C165.188 49.8489 165.257 49.845 165.301 49.8851C165.346 49.9252 165.35 49.9944 165.31 50.0393L160.125 55.8819C160.104 55.9061 160.074 55.9184 160.044 55.9184Z"
        fill="#313133"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M141.401 54.434C147.849 48.3182 158.374 48.391 165.552 54.8329C172.731 61.2753 173.995 71.7832 168.685 78.9206L141.401 54.434H141.401Z"
      fill="#51D497"
    />
    <path
      d="M168.618 79.2304C168.596 79.2304 168.574 79.2238 168.554 79.2097C168.506 79.1744 168.495 79.1057 168.53 79.0572C168.554 79.0246 170.883 75.7498 171.634 71.1727C172.325 66.9565 171.779 60.7367 165.249 55.0488C158.919 49.5342 152.818 49.7273 148.814 50.8604C144.468 52.0906 141.582 54.6614 141.553 54.687C141.508 54.7271 141.44 54.7236 141.4 54.6786C141.36 54.6337 141.363 54.5645 141.408 54.5244C141.437 54.4984 144.355 51.8975 148.746 50.6524C151.328 49.9203 153.908 49.7921 156.413 50.2707C159.543 50.8688 162.564 52.4207 165.392 54.884C168.309 57.4245 170.298 60.2832 171.306 63.3812C172.112 65.8612 172.295 68.4973 171.847 71.2168C171.086 75.8424 168.731 79.1528 168.706 79.1859C168.685 79.2154 168.652 79.2308 168.618 79.2308L168.618 79.2304Z"
      fill="#313133"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M202.72 145.113C202.72 143.876 201.723 142.873 200.493 142.873H195.866C194.637 142.873 193.64 143.876 193.64 145.113V148.941H202.72V145.113Z"
      fill="#24C178"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M183.716 152.407H212.607C212.607 152.407 211.51 149.715 210.474 148.673C208.935 147.126 206.849 146.257 204.672 146.257H191.576C189.399 146.257 187.695 146.757 185.774 148.673C184.115 150.328 183.716 152.407 183.716 152.407H183.716Z"
      fill="#51D497"
    />
    <path
      d="M205.673 146.491H190.275C190.215 146.491 190.166 146.443 190.166 146.382C190.166 146.322 190.215 146.273 190.275 146.273H205.673C205.733 146.273 205.781 146.322 205.781 146.382C205.781 146.443 205.733 146.491 205.673 146.491Z"
      fill="#313133"
    />
    <path
      d="M172.723 52.4154C172.697 52.4154 172.671 52.4062 172.651 52.3872L166.723 46.9889C166.678 46.9484 166.675 46.8792 166.715 46.8342C166.755 46.7897 166.824 46.7862 166.869 46.8267L172.797 52.225C172.842 52.2656 172.845 52.3348 172.804 52.3797C172.783 52.4035 172.753 52.4159 172.724 52.4159L172.723 52.4154Z"
      fill="#313133"
    />
    <circle cx={129.134} cy={17.9175} r={1.49976} stroke="#1D3557" strokeWidth={0.326245} />
    <circle cx={63.6906} cy={43.4741} r={1.21945} fill="#FFC72C" />
    <circle cx={119.691} cy={24.4741} r={1.21945} fill="#1D3557" />
    <path
      d="M71.5911 44.2546V46.1008M71.5911 48.4085V50.2546M74.4711 47.4853H72.5512M70.3911 47.4853H68.4711"
      stroke="#1D3557"
      strokeLinecap="round"
    />
    <path
      d="M134.591 24.2546V26.1008M134.591 28.4085V30.2546M137.471 27.4853H135.551M133.391 27.4853H131.471"
      stroke="#51D497"
      strokeLinecap="round"
    />
    <path
      d="M184.591 110.255V112.101M184.591 114.408V116.255M187.471 113.485H185.551M183.391 113.485H181.471"
      stroke="#1D3557"
      strokeLinecap="round"
    />
    <path
      d="M24.3647 74.1636L23.5238 77.7227L20.862 75.2149L24.3647 74.1636Z"
      stroke="#1D3557"
      strokeWidth={0.326245}
    />
    <path d="M187.51 100.117L190.981 101.271L188.246 103.699L187.51 100.117Z" stroke="#1D3557" strokeWidth={0.326245} />
    <defs>
      <filter
        id="filter0_i_1700_1071"
        x={23.7563}
        y={146.665}
        width={156.643}
        height={5.64523}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.07225} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix type="matrix" values="0 0 0 0 0.65098 0 0 0 0 0.764706 0 0 0 0 0.92549 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1700_1071" />
      </filter>
      <filter
        id="filter1_d_1700_1071"
        x={61.6553}
        y={65.4326}
        width={80.8448}
        height={81.2803}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius={0.804189} operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1700_1071" />
        <feOffset />
        <feGaussianBlur stdDeviation={0.562932} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <filter
        id="filter2_d_1700_1071"
        x={70.2091}
        y={74.0348}
        width={63.7371}
        height={64.0758}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius={0.804189} operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1700_1071" />
        <feOffset />
        <feGaussianBlur stdDeviation={0.562932} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <filter
        id="filter3_d_1700_1071"
        x={77.6937}
        y={81.5617}
        width={48.7679}
        height={49.0219}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius={0.804189} operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1700_1071" />
        <feOffset />
        <feGaussianBlur stdDeviation={0.562932} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <filter
        id="filter4_d_1700_1071"
        x={84.1091}
        y={88.0134}
        width={35.9371}
        height={36.1185}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius={0.804189} operator="dilate" in="SourceAlpha" result="effect1_dropShadow_1700_1071" />
        <feOffset />
        <feGaussianBlur stdDeviation={0.562932} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <filter
        id="filter5_d_1700_1071"
        x={100.011}
        y={105.619}
        width={26.4545}
        height={25.6277}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2.14451} />
        <feGaussianBlur stdDeviation={1.30011} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.207843 0 0 0 0 0.341176 0 0 0 0.29 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <filter
        id="filter6_d_1700_1071"
        x={102.075}
        y={106.61}
        width={20.3883}
        height={21.4995}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1.07225} />
        <feGaussianBlur stdDeviation={0.536126} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.207843 0 0 0 0 0.341176 0 0 0 0.53 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <filter
        id="filter7_d_1700_1071"
        x={89.9095}
        y={93.7119}
        width={23.2671}
        height={23.7792}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.268063} />
        <feGaussianBlur stdDeviation={0.536126} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1700_1071" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1700_1071" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_1700_1071"
        x1={173.471}
        y1={21.2546}
        x2={131.49}
        y2={128.065}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#51D497" />
        <stop offset={1} stopColor="#51D497" stopOpacity={0} />
      </linearGradient>
      <clipPath id="clip0_1700_1071">
        <rect width={130.179} height={75.0008} fill="white" transform="translate(37.1218 68.4379)" />
      </clipPath>
    </defs>
  </svg>
);
export default DesktopAlertSVG;
